import styled from "styled-components";

export const StyledMatrixContent = styled.div`
  height: 100%;
  flex-direction: column;
  display: flex;
  overflow-y: auto;
  padding: 20px;
  gap: 20px;
  overflow-x: hidden;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.XL}px) {
    overflow-x: auto;
  }

  & .filters-container {
    display: flex;
    padding-left: 32px;
    gap: 16px;
    min-width: 0;
  }
`;
